const allowedRedirectUris = (import.meta.env.VITE_MCP_ALLOWED_REDIRECT_URIS ?? "")
  .split(",").map(value => value.trim()).filter(Boolean);
const responseParameters = new Set(["code", "state", "error", "error_description", "error_uri", "iss"]);

function parseRedirectUrl(value: string): URL {
  const url = new URL(value);
  const loopback = ["localhost", "127.0.0.1", "[::1]"].includes(url.hostname);
  if ((url.protocol !== "https:" && !(url.protocol === "http:" && loopback)) ||
      url.username || url.password || url.hash || value.includes("\\") || [...value].some(character => character.charCodeAt(0) <= 32)) {
    throw new Error("The authorization server returned an unsafe redirect.");
  }
  return url;
}

export function providerRedirectUrl(value: string): string {
  const url = parseRedirectUrl(value);
  const allowed = allowedRedirectUris.some(uri => {
    let registered: URL;
    try { registered = parseRedirectUrl(uri); }
    catch { return false; }
    if (url.origin !== registered.origin || url.pathname !== registered.pathname) return false;
    for (const [key, expected] of registered.searchParams) {
      if (registered.searchParams.getAll(key).length !== 1 ||
          url.searchParams.getAll(key).length !== 1 || url.searchParams.get(key) !== expected) return false;
    }
    for (const key of url.searchParams.keys()) {
      if (url.searchParams.getAll(key).length !== 1 ||
          (!registered.searchParams.has(key) && !responseParameters.has(key))) return false;
    }
    return true;
  });
  if (!allowed) throw new Error("The authorization server returned an unapproved redirect.");
  return url.href;
}

// Call only with redirect_url returned by the authenticated authorization provider, never URL query input.
export function navigateToProviderRedirect(value: string) {
  if (window.ReactNativeWebView || window.self !== window.top) {
    throw new Error("Complete this authorization in your browser.");
  }
  window.location.replace(providerRedirectUrl(value));
}
